import React from "react";
import BgFirstContainer from "./BgFirstContainer";
import VehicleSlider from './VehicleSlider.jsx'
import InspirationCard from './InspirationCard.jsx'
import HostContainer from "./HostContainer.jsx";
import CdlContainer from "./CdlContainer.jsx";
import TopCities from "./TopCities.jsx";
import RideHireFeatures from "./RideHireFeatures.jsx";
import Footer from "./Footer.jsx";
// Use another image if needed

const UserHome = () => {
  

    return (
        <>
            <BgFirstContainer />
            <VehicleSlider/>

            <InspirationCard/>
            <HostContainer/>
            <CdlContainer/>
            <TopCities/>
            <RideHireFeatures/>
            <Footer/>

        </>
    );
};

export default UserHome;
